function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.758.003c-.015-.002-.032-.002-.05-.002a.507.507 0 00-.502.442v.003l-1 9a.5.5 0 00.44.552h.002a.5.5 0 00.552-.44v-.002l1-9a.5.5 0 00-.44-.552h-.002zm-2 0a.508.508 0 00-.552.44v.003l-1 9a.5.5 0 00.44.552h.002a.5.5 0 00.552-.44v-.002l1-9a.5.5 0 00-.44-.552h-.002zM15 6a8.907 8.907 0 00-4.123 1.005l.05-.023-.726-6.537a.501.501 0 00-.973-.098l-.001.004-1.522 4.844L6.184.351a.5.5 0 00-.974.092v.002l-1.003 9a.5.5 0 00.994.112v-.002l.74-6.64 1.286 4.097a.5.5 0 00.953.003l.001-.004 1.288-4.098.513 4.615C7.567 9.167 6 11.9 6 14.999a9 9 0 109-9zm4.606 9.447l-7.211 3.606a.57.57 0 01-.893-.556v.003-7a.57.57 0 01.896-.552l-.002-.001 7.211 3.606c.492.246.492.648 0 .894z"
});

function SvgMdResumed(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "mdResumed.85b7c.svg";
export { SvgMdResumed as ReactComponent };